/* global axios */
import ApiClient from './ApiClient';

const getTimeOffset = () => -new Date().getTimezoneOffset() / 60;

class ReportsAPI extends ApiClient {
  constructor() {
    super('reports', { accountScoped: true, apiVersion: 'v2' });
  }

  getMessageData({ id } = {}) {
    return axios.get(`${this.url}/message_data`, {
      params: {
        id: id,
      },
    });
  }

  getReports({
    metric,
    from,
    to,
    type = 'account',
    id,
    groupBy,
    businessHours,
  }) {
    return axios.get(`${this.url}`, {
      params: {
        metric,
        since: from,
        until: to,
        type,
        id,
        group_by: groupBy,
        business_hours: businessHours,
        timezone_offset: getTimeOffset(),
      },
    });
  }

  // eslint-disable-next-line default-param-last
  getSummary(since, until, type = 'account', id, groupBy, businessHours) {
    return axios.get(`${this.url}/summary`, {
      params: {
        since,
        until,
        type,
        id,
        group_by: groupBy,
        business_hours: businessHours,
        timezone_offset: getTimeOffset(),
      },
    });
  }

  getAccountReports(metric, since, until, agents, channels) {
    return axios.get(`${this.url}/account`, {
      params: { metric, since, until, agents, channels },
    });
  }

  getAccountSummary(since, until, agents, channels) {
    return axios.get(`${this.url}/account_summary`, {
      params: { since, until, agents, channels },
    });
  }

  getAccountCircle(since, until, agents, channels) {
    return axios.get(`${this.url}/account_circle`, {
      params: { since, until, agents, channels },
    });
  }

  getConversationMetric(type = 'account', page = 1) {
    return axios.get(`${this.url}/conversations`, {
      params: {
        type,
        page,
      },
    });
  }

  getAgentReports(conditions) {
    return axios.get(`${this.url}/agents`, {
      params: conditions,
    });
  }

  getUserTable(since, until, agents, channels) {
    return axios.get(`${this.url}/agent_table`, {
      params: { since, until, agents, channels },
    });
  }

  getChannelReports(metric, since, until, channels, teams) {
    return axios.get(`${this.url}/channel`, {
      params: { metric, since, until, channels, teams },
    });
  }

  getChannelSummary(since, until, channels, teams) {
    return axios.get(`${this.url}/channel_summary`, {
      params: { since, until, channels, teams },
    });
  }

  downloadTeamreports(conditions) {
    return axios.get(`${this.url}/teams_export`, {
      params: conditions,
    });
  }

  downloadChannelReports(conditions) {
    return axios.get(`${this.url}/inboxes`, {
      params: conditions,
    });
  }

  downloadServiceCommentReports(conditions) {
    return axios.get(`${this.url}/service_comment_export`, {
      params: conditions,
    });
  }

  downloadWorkhoursReports(conditions) {
    return axios.get(`${this.url}/workhours_export`, {
      params: conditions,
    });
  }

  getLabelReports(metric, since, until, searchkey, channels) {
    return axios.get(`${this.url}/labels`, {
      params: { metric, since, until, searchkey, channels },
    });
  }

  getLabelSummary(since, until) {
    return axios.get(`${this.url}/label_summary`, {
      params: { since, until },
    });
  }

  downloadLabelReports(conditions) {
    return axios.get(`${this.url}/label_export`, {
      params: conditions,
    });
  }

  getTeamReports(metric, since, until, teams, channels) {
    return axios.get(`${this.url}/teams`, {
      params: { metric, since, until, teams, channels },
    });
  }

  getTeamSummary(since, until, teams, channels) {
    return axios.get(`${this.url}/team_summary`, {
      params: { since, until, teams, channels },
    });
  }

  downloadTeamReports(since, until) {
    return axios.get(`${this.url}/team_resports`, {
      params: { since, until },
    });
  }

  getPeriodSummary(since, until, agents, channels) {
    return axios.get(`${this.url}/period_summary`, {
      params: { since, until, agents, channels },
    });
  }

  getPeriodReports(since, until, agents, channels) {
    return axios.get(`${this.url}/period`, {
      params: { since, until, agents, channels },
    });
  }

  downloadPeriodReports(conditions) {
    return axios.get(`${this.url}/period_export`, {
      params: conditions,
    });
  }

  getWorkhoursSummary(since, until, agents) {
    return axios.get(`${this.url}/workhours_summary`, {
      params: { since, until, agents },
    });
  }

  getWorkhoursReports(since, until, agents) {
    return axios.get(`${this.url}/workhours`, {
      params: { since, until, agents },
    });
  }

  getDialogSummary(since, until, agents, channels) {
    return axios.get(`${this.url}/dialog_summary`, {
      params: { since, until, agents, channels },
    });
  }

  getDialogReports(since, until, agents, channels) {
    return axios.get(`${this.url}/dialog`, {
      params: { since, until, agents, channels },
    });
  }

  downloadDialogReports(conditions) {
    return axios.get(`${this.url}/dialog_export`, {
      params: conditions,
    });
  }

  getServiceCommentSummary(since, until, agents, channels, teams, csat) {
    return axios.get(`${this.url}/service_comment_summary`, {
      params: { since, until, agents, channels, teams, csat },
    });
  }

  getServiceCommentReports(since, until, agents, channels, teams, csat) {
    return axios.get(`${this.url}/service_comment`, {
      params: { since, until, agents, channels, teams, csat },
    });
  }
}

export default new ReportsAPI();
